import { Label, Typography } from "neetoui";
import { useTranslation } from "react-i18next";

const PublishPreview = ({ coverImageUrl, title, publicUrl }) => {
  const { t } = useTranslation();

  if (!title) return null;

  return (
    <div className="flex flex-col">
      <Label className="mb-2">{t("neetoMolecules.publishBlock.preview")}</Label>
      <div className="neeto-ui-rounded neeto-ui-bg-gray-100 w-full p-4">
        <div className="flex flex-col items-start gap-3">
          {coverImageUrl && (
            <div className="w-full flex-shrink-0">
              <img
                alt={title}
                className="neeto-ui-rounded h-52 w-full object-cover"
                src={coverImageUrl}
              />
            </div>
          )}
          <div className="flex w-full min-w-0 flex-col items-start gap-1">
            <Typography className="break-words" style="h4" weight="medium">
              {title}
            </Typography>
            {publicUrl && (
              <a
                className="neeto-ui-text-info-600 break-all"
                href={publicUrl}
                rel="noopener noreferrer"
                target="_blank"
              >
                {publicUrl}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishPreview;
